// tslint:disable:max-line-length
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { E5coreUiWorkFieldTypeBase } from '../e5core-ui-work-field/e5core-ui-work-field-type-base';
import { WorkFieldCheckboxChangeEvent } from '../../events/work-field-checkbox-change-event';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field-type-checkbox',
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-work-field-type-checkbox-box *ngSwitchCase='0' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-checkbox-box>
    <e5core-ui-work-field-type-checkbox-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-checkbox-bootstrap>
    <e5core-ui-work-field-type-checkbox-material *ngSwitchCase='2' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-checkbox-material>
  </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkFieldTypeCheckboxComponent extends E5coreUiWorkFieldTypeBase {

  constructor(public style:UiStyleService) {
    super() ;
  }

  valueChange($event: WorkFieldCheckboxChangeEvent) {
    if (typeof($event.value) === 'undefined') {
      return ;
    } // prevents and odd <input> problem when event arrives twice
    this.dispatchPropertyChange(this.property.propertyId, $event.value ? 'True' : 'False', $event.error);
  }

}
